/* AlloSwitch: random available accessory selection on every page visit.
   Use the actual Shopify collection product data and keep server-rendered cards as no-JS fallback. */
(function(){
  function shuffle(list) {
    var a=list.slice();
    for(var i=a.length-1;i>0;i--){
      var j=Math.floor(Math.random()*(i+1));
      var tmp=a[i];a[i]=a[j];a[j]=tmp;
    }
    return a;
  }
  function element(tag,className,text){
    var e=document.createElement(tag);
    if(className)e.className=className;
    if(text!=null)e.textContent=String(text);
    return e;
  }
  function makeCard(item,action){
    var article=element('article','allo-exact-accessory');
    article.setAttribute('data-allo-accessory-id',String(item.id));
    var imageLink=element('a','allo-exact-accessory-image');
    imageLink.href=item.url;
    if(item.image){
      var img=element('img');
      img.src=item.image;
      img.alt=item.title;
      img.loading='lazy';
      img.decoding='async';
      imageLink.appendChild(img);
    }
    article.appendChild(imageLink);
    var content=element('div','allo-exact-accessory-content');
    var title=element('a','allo-exact-accessory-title',item.title);
    title.href=item.url;content.appendChild(title);
    content.appendChild(element('strong','',item.price));
    if(item.variantCount===1 && item.variantId){
      var form=element('form');
      form.method='post';form.action=action;
      var id=element('input');id.type='hidden';id.name='id';id.value=String(item.variantId);
      var count=element('input');count.type='hidden';count.name='quantity';count.value='1';
      form.appendChild(id);form.appendChild(count);
      var button=element('button','','Ajouter');button.type='submit';form.appendChild(button);
      content.appendChild(form);
    }else{
      var choose=element('a','allo-exact-choose','Choisir');
      choose.href=item.url;content.appendChild(choose);
    }
    article.appendChild(content);
    return article;
  }
  function randomize(section){
    var grid=section.querySelector('[data-allo-accessories-grid]');
    var dataTag=section.querySelector('[data-allo-accessories-pool]');
    if(!grid || !dataTag)return;
    var data;
    try{data=JSON.parse(dataTag.textContent)}catch(e){return}
    if(!data || !Array.isArray(data.items))return;
    var current=String(section.dataset.alloMainProductId||'');
    var available=data.items.filter(function(item){
      return item && item.available===true && String(item.id)!==current && item.title && item.url;
    });
    // Product feeds can contain giftware or digital cards mislabeled as accessories.
    // Keep practical, physical gaming accessories in this random selection.
    var practical=/(joy[- ]?con|manette|pochette|housse|sacoche|support|grip|protection|incassable|verre tremp|micro ?sd|carte mémoire|dock|station de charge|chargeur|câble|cable|bo[iî]tier|rangement|dragonne|caméra|camera|adaptateur|coque|[eé]tui|batterie|poign[eé]e|genki shadowcast|capture)/i;
    var unrelated=/(carte playstation|playstation store|psn|steam deck|xbox|elgato|tasses|espresso|mug|coffret cadeau|figurine)/i;
    var pool=available.filter(function(item){
      return practical.test(item.title) && !unrelated.test(item.title);
    });
    if(pool.length<5)pool=available;
    if(!pool.length)return;
    var storageKey='allo-accessories-last-'+String(section.dataset.alloCollection||'general');
    var previous=[];
    try{previous=JSON.parse(sessionStorage.getItem(storageKey)||'[]')}catch(e){}
    if(!Array.isArray(previous))previous=[];
    var unseen=shuffle(pool.filter(function(p){return previous.indexOf(String(p.id))<0}));
    var seen=shuffle(pool.filter(function(p){return previous.indexOf(String(p.id))>=0}));
    var chosen=unseen.concat(seen).slice(0,5);
    try{sessionStorage.setItem(storageKey,JSON.stringify(chosen.map(function(p){return String(p.id)})))}catch(e){}
    // Build before replacing; the existing five cards remain intact on any unexpected failure.
    var fragment=document.createDocumentFragment();
    chosen.forEach(function(item){
      fragment.appendChild(makeCard(item,section.dataset.alloCartAddUrl||'/cart/add'));
    });
    grid.replaceChildren(fragment);
    section.dataset.alloPoolSize=String(pool.length);
  }
  function init(){
    document.querySelectorAll('[data-allo-random-accessories]').forEach(function(section){
      if(section.dataset.alloRandomReady==='1')return;
      section.dataset.alloRandomReady='1';
      randomize(section);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(event){
    var section=event.target&&event.target.querySelector('[data-allo-random-accessories]');
    if(section){section.removeAttribute('data-allo-random-ready');init()}
  });
  window.addEventListener('pageshow',function(event){
    if(event.persisted){
      document.querySelectorAll('[data-allo-random-accessories]').forEach(function(s){s.removeAttribute('data-allo-random-ready')});
      init();
    }
  });
})();
